import { autoinject, bindingMode } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { HelpService } from 'app/shared/services/help-service';
import { bindable } from 'aurelia-typed-observable-plugin';


@autoinject()
export class EssIconHelpCustomElement extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    @bindable.stringNull({ defaultBindingMode: bindingMode.toView, changeHandler: 'reload' })
    protected topic: string = 'core.$root';

    protected helpUrl: string = '';

    ////****************** Element References ***************************************////


    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        private readonly helpService: HelpService,
        ...rest: any[]) {

        super(...rest);
        this.logger.source = this;
    }
    //protected async activate(params: any, routeConfig: RouteConfig, navInstruction: NavigationInstruction): Promise<void> {}
    //protected created(owningView: View, myView: View): void { }

    protected bind(): void {
        this.reload()
    }

    //protected attached(): void { }
    //protected deactivate(): void { }
    //protected detached(): void { }
    //protected unbind(): void { }


    ////****************** Events ***************************************************////


    ////****************** Functions ************************************************////
    protected async reload(): Promise<void> {
        this.helpUrl = await this.helpService.resolveHelpUrl(this.topic);
    }

    private async help(): Promise<void> {
        if(this.helpUrl.length === 0) return;

        const helpWindow = window.open('', this.env.config.help.windowTarget);

        if(!helpWindow) { return; }

        helpWindow.location.replace(this.helpUrl);
    }


    ////****************** Service Calls ********************************************////

}
